import { Navigate } from 'react-router-dom'

export default function LandingPage() {
  return <Navigate to="/login" replace />
}
